module.exports = __webpack_public_path__ + "static/fonts/382A4A_1_0.85bef1f.ttf";